export default [
  {
    path: "/bkzx",
    name: "bkzx",
    component: (resolve) => require(["@/views/PCView/bkzx/index.vue"], resolve),
  },
  {
    path: "bkzxdetail",
    name: "bkzxdetail",
    component: (resolve) => require(["@/views/PCView/bkzx/BkzxDetail.vue"], resolve),
    // redirect: "/bkzxdetail/bkzxmain",
    // children: [
    //   {
    //     path: "/bkzxdetail/bkzxmain",
    //     name: "bkzxmain",
    //     component: (resolve) =>
    //       require(["@/views/PCView/bkzx/view/Main.vue"], resolve),
    //   },
    //   {
    //     path: "/bkzxdetail/bkzxblog",
    //     name: "bkzxblog",
    //     component: (resolve) =>
    //       require(["@/views/PCView/bkzx/view/Blog.vue"], resolve),
    //   },
    //   {
    //     path: "/bkzxdetail/bkzxpaper",
    //     name: "bkzxpaper",
    //     component: (resolve) =>
    //       require(["@/views/PCView/bkzx/view/Paper.vue"], resolve),
    //   },
    //   {
    //     path: "/bkzxdetail/bkzxzgh",
    //     name: "bkzxzgh",
    //     component: (resolve) => require(["@/views/PCView/bkzx/view/Zgh.vue"], resolve),
    //   },
    //   {
    //     path: "/bkzxdetail/bkvideo",
    //     name: "bkvideo",
    //     component: (resolve) =>
    //       require(["@/views/PCView/bkzx/view/BkVideo.vue"], resolve),
    //   },
    //   {
    //     path: "/bkzxdetail/bkmonograph",
    //     name: "bkmonograph",
    //     component: (resolve) =>
    //       require(["@/views/PCView/bkzx/view/BkMonograph.vue"], resolve),
    //   },
    // ],
  },
];
